import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
	API_URL,
	scroll,
	fmtCurrency,
	getValFromLS,
	setValToLS,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Radios from "../components/Radios";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Steps from "./Steps";
// import Credit from "./Credit"; // First Data, not used
import Check from "./Check";

const RegPayment = () => {
	const [order, setOrder] = useState([]);
	const [, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const formElement = useRef();
	const formElement2 = useRef();

	//let total = JSON.parse(getValFromLS("order", true)).level.amt || 0;

	let total = 0;

	useEffect(() => {
		const init = async () => {
			if (getValFromLS("auth", true) && getValFromLS("order", true)) {
				const authFromLS = JSON.parse(getValFromLS("auth", true));
				const orderFromLS = JSON.parse(getValFromLS("order", true));

				const url = new URL(`${API_URL}/registrationPaymentInit`);
				const params = {
					id: authFromLS.id,
					orderId: orderFromLS.orderId,
				};
				url.search = new URLSearchParams(params);

				try {
					const response = await fetch(url, {
						method: "GET",
						cache: "no-store",
					});
					const json = await response.json();
					if (json && json.resp === 1) {
						setOrder(json.items);

						/*
						const newOrder = {
							level: orderFromLS.level,
							addons: [],
						};

						setOrder(newOrder);
						setValToLS("order", JSON.stringify(newOrder), true);
						setAddOnData(json.addons);
						*/
						handleUpdate("email", authFromLS.email);
						setAlert({});
						scroll();
					}
				} catch (error) {
					setAlert({
						type: "error",
						text: "An error has occurred.",
					});
				}
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/registrationPayment`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("order", getValFromLS("order", true));
		data.append("auth", getValFromLS("auth", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				/* sequence is orderId */
				if (json.payment === "credit") {
					formElement2.current.action = json.action;
					formElement2.current.x_login.value = json.login;
					formElement2.current.x_amount.value = json.amt;
					formElement2.current.x_currency_code.value = json.currency;
					formElement2.current.x_fp_sequence.value = json.sequence;
					formElement2.current.x_fp_timestamp.value = json.ts;
					formElement2.current.x_fp_hash.value = json.hash;

					/* copy session to local to persist data */
					setValToLS("auth", getValFromLS("auth", true));
					setValToLS("order", getValFromLS("order", true));

					handleCredit();
				} else {
					handleSubmitted("check", json.dashId);
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleCredit = () => {
		formElement2.current.submit();
	};

	const handleSubmitted = (method, dashId) => {
		let orderFromLS = JSON.parse(getValFromLS("order", true));
		orderFromLS.payment = method;
		setValToLS("order", JSON.stringify(orderFromLS), true);

		history.push("/registration/submitted");
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>6</h1>
							<div>
								<p>
									Please select mail a check / ACH / wire transfer or pay later
									with a credit or debit card to complete and submit your
									sponsorship registration. If you would like to discuss other
									payment options, please email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						<table
							className="approved"
							style={{ marginTop: "25px", marginBottom: "25px" }}
						>
							<thead>
								<tr>
									<th className="left" style={{ width: "75%" }}>
										Sponsor Level
									</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								{order.map((item) => {
									const subtotal = item.qty * item.amt;
									total = total + subtotal;

									return (
										<tr key={item.id}>
											<td className="left">
												<p
													style={{
														margin: "0",
														marginTop: "5px",
														fontSize: "1.1rem",
													}}
												>
													{item.id === "tickets"
														? `${item.name} (${item.qty})`
														: item.name}
												</p>
												{item.bullets.length > 0 && (
													<ul
														style={{
															marginTop: "5px",
															marginBottom: "0",
														}}
													>
														{item.bullets.map((bullet, index) => {
															return <li key={index}>{bullet}</li>;
														})}
													</ul>
												)}
											</td>
											<td className="right">{fmtCurrency(subtotal / 100)}</td>
										</tr>
									);
								})}
							</tbody>

							<tfoot>
								<tr>
									<th className="right" style={{ paddingRight: "10px" }}>
										TOTAL
									</th>
									<th className="right">{fmtCurrency(total / 100)}</th>
								</tr>
							</tfoot>
						</table>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h3 style={{ marginTop: "0" }}>Payment Method</h3>

							{/* removed b/c of change to authorize.net on 3/1/23, 
									will need to add for 2027, refer to 
									/Dashboard/Invoice.js for authnet integration
							
								{
											name: "payment",
											val: "credit",
											label: "Pay Now - Credit or Debit Card",
										},
							
							
							*/}

							<div className="form-group radios" style={{ marginTop: "15px" }}>
								<Radios
									label="Please select your payment method:"
									reqd={true}
									data={[
										{
											name: "payment",
											val: "check",
											label:
												"Pay Later - Mail a Check / ACH, Wire Transfer or Credit Card",
										},
									]}
									value={names.payment || ""}
									click={handleUpdate}
								/>
							</div>

							{/* this was used when processor was First Data
								names.payment === "credit" && (
									<Credit
										update={handleUpdate}
										data={{
											number: names.number || "",
											expdate: names.expdate || "",
											code: names.code || "",
											amt:
												names.amt === "other" && names.other > 0
													? names.other
													: names.amt
													? names.amt
													: 0,
										}}
										errors={errors}
									/>
							)*/}

							{names.payment === "check" && <Check email={names.email} />}

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit={
											names.payment === "credit"
												? "Continue to Payment Form"
												: "Generate Invoice & Complete"
										}
									/>
								</div>
							</div>
						</form>

						<form ref={formElement2} method="post" action="">
							<input name="x_login" value="" type="hidden" />
							<input name="x_amount" value="" type="hidden" />
							<input name="x_currency_code" value="" type="hidden" />
							<input name="x_fp_sequence" value="" type="hidden" />
							<input name="x_fp_timestamp" value="" type="hidden" />
							<input name="x_fp_hash" value="" type="hidden" />
							<input name="x_show_form" value="PAYMENT_FORM" type="hidden" />
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Steps on={6} user={JSON.parse(getValFromLS("auth", true))} />
					</div>
				</>
			)}
		</>
	);
};

export default RegPayment;
